import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Shield, X } from "lucide-react";

const STORAGE_KEY = "jbsa-banner-dismissed";

const MilitaryMobileBanner = () => {
  const [isDismissed, setIsDismissed] = useState(true); // Start hidden to prevent flash

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    setIsDismissed(dismissed === "true");
  }, []);

  const handleDismiss = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    localStorage.setItem(STORAGE_KEY, "true");
    setIsDismissed(true);
  };

  if (isDismissed) return null;

  return (
    <div 
      className="fixed top-20 left-0 right-0 z-40 lg:hidden flex items-center justify-between px-4 py-3 bg-gradient-to-r from-[#0a0f1a] via-[#111827] to-[#0a0f1a] border-b-2 border-blue-400/60 backdrop-blur-sm overflow-hidden"
      style={{ 
        animation: "slideDown 0.4s ease-out, pulseBlueGlow 2s ease-in-out infinite",
        boxShadow: "0 0 20px rgba(59, 130, 246, 0.5), 0 4px 30px rgba(59, 130, 246, 0.3)"
      }}
    >
      {/* Rotating clockwise glow overlay */}
      <div 
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{
          background: "conic-gradient(from 0deg, transparent, rgba(59, 130, 246, 0.5), transparent, transparent)",
          animation: "spinClockwise 3s linear infinite"
        }}
      />
      <Link 
        to="/jbsa-military-transportation"
        className="flex items-center gap-2 flex-1 relative z-10"
        aria-label="Learn more about JBSA transportation"
      >
        <Shield className="w-5 h-5 text-blue-400 drop-shadow-[0_0_10px_rgba(59,130,246,0.9)]" />
        <span className="text-white font-semibold text-sm drop-shadow-[0_0_8px_rgba(59,130,246,0.5)]">JBSA Access Approved</span>
      </Link>
      <div className="flex items-center gap-2">
        <Link 
          to="/jbsa-military-transportation"
          className="bg-primary text-primary-foreground px-3 py-1.5 rounded-md text-sm font-bold shadow-[0_0_15px_rgba(212,175,55,0.5)]"
        >
          JBSA Access Info
        </Link>
        <button
          onClick={handleDismiss}
          className="p-1.5 text-white/60 hover:text-white transition-colors"
          aria-label="Dismiss banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default MilitaryMobileBanner;
